import React from "react";
import Letop from "../allpages/Letop";

export default () => (
  <div>
    <div className="table">
      <table>
        <tr>
          <th className="col bor-bot" />
          <th>1e decl.</th>
          <th>2e decl.</th>
          <th>3e decl.</th>
        </tr>
        <tr>
          <th className="col">nom. ev.</th>
          <td>
            femin–
            <strong>a</strong>
          </td>
          <td>
            serv–
            <strong>us</strong>
          </td>
          <td>rex</td>
        </tr>
        <tr>
          <th className="col">dat. ev.</th>
          <td>
            femin–
            <strong>ae</strong>
          </td>
          <td>
            serv–
            <strong>o</strong>
          </td>
          <td>
            reg–
            <strong>i</strong>
          </td>
        </tr>
        <tr>
          <th className="col bor-bot">acc. ev.</th>
          <td className="bor-bot">
            femin–
            <strong>am</strong>
          </td>
          <td className="bor-bot">
            serv–
            <strong>um</strong>
          </td>
          <td className="bor-bot">
            reg–
            <strong>em</strong>
          </td>
        </tr>
        <tr>
          <th className="col">nom. mv.</th>
          <td>
            femin–
            <strong>ae</strong>
          </td>
          <td>
            serv–
            <strong>i</strong>
          </td>
          <td>
            reg–
            <strong>es</strong>
          </td>
        </tr>
        <tr>
          <th className="col">dat. mv.</th>
          <td>
            femin–
            <strong>is</strong>
          </td>
          <td>
            serv–
            <strong>is</strong>
          </td>
          <td>
            reg–
            <strong>ibus</strong>
          </td>
        </tr>
        <tr>
          <th className="col">acc. mv.</th>
          <td>
            femin–
            <strong>as</strong>
          </td>
          <td>
            serv–
            <strong>os</strong>
          </td>
          <td>
            reg–
            <strong>es</strong>
          </td>
        </tr>
      </table>
    </div>
    <p>
      <Letop>
        De nominativus enkelvoud in <strong>rex</strong> heeft geen uitgang. Dat
        komt omdat deze vorm onregelmatig is. Om de stam te bepalen moet je de
        meervoudsvorm leren (of opzoeken).
      </Letop>
    </p>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/tables/znw-2.js